import { Migration } from '@mikro-orm/migrations';

export class Migration20250903000001_CreateFileTable extends Migration {
  async up(): Promise<void> {
    this.addSql(`
      create table "file" (
        "id" serial primary key,
        "url" varchar(255) not null,
        "user_id" integer not null,
        "created_at" timestamptz(0) not null,
        "updated_at" timestamptz(0) not null,
        "deleted_at" timestamptz(0) null,
        constraint "file_user_foreign" foreign key ("user_id") references "user" ("id") on delete cascade
      );
    `);
  }

  async down(): Promise<void> {
    this.addSql('drop table if exists "file" cascade;');
  }
}
